module.exports = __webpack_public_path__ + "img/image02.9095ff52.jpg";